<script setup lang="ts">
import { useIsMobile } from '@/composables/useMediaQuery'
import { computed } from 'vue'
const isMobile = useIsMobile()

const props = defineProps<{
  padding?: string
  backgroundColor?: string
}>()

const padding = computed(() => props.padding || '40px')
const backgroundColor = computed(() => props.backgroundColor || 'var(--gray-900)')
</script>

<template>
  <div class="base-layout" :class="{ 'mobile-layout': isMobile }">
    <div class="base-layout-container" :class="{ 'mobile-layout-container': isMobile }">
      <slot> </slot>
    </div>
  </div>
</template>

<style scoped>
.base-layout {
  width: 100%;
  min-height: calc(100vh - 100px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: v-bind(backgroundColor);
  box-sizing: content-box;
}

.base-layout-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: v-bind(padding);
  box-sizing: content-box;
}

.base-layout.mobile-layout {
  min-height: calc(100vh - 48px);
}

.base-layout-container.mobile-layout-container {
  padding: 0;
}

@media (max-width: 1365px) {
  .base-layout-container {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    box-sizing: content-box;
  }

  .base-layout-container.mobile-layout-container {
    padding: 0px 0px 100px 0px;
  }
}
</style>
